import {Component, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StoreService} from '../store.service';
import {PlatformLocation} from '@angular/common';
import {CommonService} from '../common.service';
import {
  getErrorMsg,
  hasFormalLoginToken,
  isCompanyAccountInvalid,
  isCompanySelectionExpired
} from '../login-error.util';

interface LoginData {
  password?: string;
  // 其他可能的属性
  [key: string]: any; // 如果还有其他不确定的属性，可以加上这行
}
@Component({
  selector: 'app-course-select',
  templateUrl: './course-select.component.html',
  styleUrls: ['./course-select.component.css',]
})
export class CourseSelectComponent implements OnInit {
  assetsRoute: string = "../../assets";
  isOpenClass: number;
  targetUrl: string;
  courseList = [];
  loginData: LoginData = {};
  isEnter:boolean = false; //是否进入
  isInitialSelect = false;
  selecting = false;
  tipMessage = '';
  messageBoxOpen = false;
  constructor(private apiService: ApiService,
              private store: StoreService,
              private commonService: CommonService,
              private router: Router,
              private route : ActivatedRoute,
              private platformLocation: PlatformLocation
  ) { }

  openMessageBox(message?: string){
    if (message) {
      this.tipMessage = message;
    }
    this.messageBoxOpen = true;
    setTimeout(() => {
      this.messageBoxOpen = false;
    }, 2000);
  }

  handleItemClick(data){
    if (this.selecting) {
      return;
    }
    localStorage.setItem('themeBG', data.type);
    console.log('点击了',data.id);
    const currentToken = localStorage.getItem('transtalen-token');
    const isSwitch = !this.isInitialSelect && !!currentToken;
    let sendData;
    if (isSwitch) {
      sendData = this.commonService.buildCompanyReloginPayload(this.loginData, data.id, {
        switchCompany: true,
        token: currentToken
      });
    } else {
      const selectionToken = this.loginData && this.loginData.companySelectionToken;
      if (!selectionToken) {
        this.router.navigate(['new-login']);
        return;
      }
      sendData = this.commonService.buildPhoneCompanySelectPayload(data.id, selectionToken);
    }
    console.log(sendData)
    this.selecting = true;
    this.apiService.loginInPhoneOrAccount(sendData, { withToken: isSwitch }).subscribe(res=>{
      this.selecting = false;
      console.log(res,'多学员登录返回数据----------------------------------')
      if(hasFormalLoginToken(res)){
        localStorage.setItem('transtalen-token',res.token);
        if (res.userIdEncoder) {
          localStorage.setItem('transtalenuserid',res.userIdEncoder);
        }
        this.apiService.setHeaders();//header设置
        if (this.loginData) {
          delete this.loginData.protectionChallengeToken;
          delete this.loginData.companySelectionToken;
        }
        const rawLoginData = localStorage.getItem('loginData');
        if (rawLoginData) {
          try {
            const stored = JSON.parse(rawLoginData);
            delete stored.protectionChallengeToken;
            delete stored.companySelectionToken;
            localStorage.setItem('loginData', JSON.stringify(stored));
          } catch (e) {}
        }
        if(this.isOpenClass ===1){
          this.platformLocation['location']['href'] = this.platformLocation['location']['origin']+'/ddilearner/v1/user/authorize?token='+ res.token + '&' +this.targetUrl;
        }else{
          this.router.navigate(['learning-map','-1']);
        }
      } else {
        this.router.navigate(['new-login']);
      }
    }, error => {
      this.selecting = false;
      const message = getErrorMsg(error);
      if (isCompanyAccountInvalid(message)) {
        this.openMessageBox(message || '该公司账号已失效');
        return;
      }
      if (isCompanySelectionExpired(message)) {
        this.commonService.clearCompanySelectionState();
        this.openMessageBox(message || '登录验证已失效，请重新验证');
        this.router.navigate(['new-login']);
        return;
      }
      this.openMessageBox(message || '登录失败，请重试');
    });
  }
  handleCompanyList(orignCompanyList){
    let courseList = []
    orignCompanyList.forEach(element => {
      let type = element.companiesType;
      let item = {
        type:'company',
        title:'公司课程',
        description:element.name,
        id:element.id,
        state:element.state,
        name: element.name
      }
      if(type == 1){
        item.type = 'open'
        item.title = '公开课'
      }else if(type == 2){
        item.type = 'experience'
        item.title = '体验课'
      }
      if(item.state === 1){
        courseList.push(item)
      }
    });
    this.courseList = courseList
  }

  hasCachedCompanyList() {
    const cachedList = this.loginData && this.loginData.companyList;
    return Array.isArray(cachedList) && cachedList.filter(item=>item.state === 1).length > 1;
  }

  hasSelectionToken() {
    return !!(this.loginData && this.loginData.companySelectionToken);
  }

  getCompanyList(){
    try {
      this.loginData = JSON.parse(localStorage.getItem('loginData') || '{}') as LoginData;
    } catch (e) {
      this.loginData = {};
    }
    if (this.loginData && this.loginData.password) {
      this.loginData.password = this.commonService.xorDecrypt(this.loginData.password, this.commonService.xorKey);
    }

    this.route.queryParams.subscribe(params => {
      this.isInitialSelect = 'notSelectCompany' in params;
      const hasToken = !!localStorage.getItem('transtalen-token');
      if(this.isInitialSelect){
        if(this.hasCachedCompanyList() && this.hasSelectionToken()){
          this.handleCompanyList(this.loginData.companyList)
        }else{
          this.router.navigate(['new-login']);
        }
        return;
      }
      if(!hasToken){
        if(this.hasCachedCompanyList() && this.hasSelectionToken()){
          this.isInitialSelect = true;
          this.handleCompanyList(this.loginData.companyList)
        }else{
          this.router.navigate(['new-login']);
        }
        return;
      }
      this.apiService.getCompanyList().subscribe(result => {
        if(Array.isArray(result) && result.filter(item=>item.state === 1).length > 1){
          this.handleCompanyList(result)
        }else{
          this.router.navigate(['/learning-map'])
        }
      })
    })
  }
  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.targetUrl = localStorage.getItem('targetUrl') ? localStorage.getItem('targetUrl') : null;
    this.isOpenClass = Number(localStorage.getItem('openClass'))?1:0;
    this.getCompanyList();
    setTimeout(()=>{
      this.isEnter = true;
    },200);

  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor': '#F5F5F5'
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/course-select/course-select.component.ts